<template>
  <div class="login-container">
    <!-- LEFT -->
    <div class="left-section">
      <img :src="loginImg" class="bg-img" />

      <div class="overlay">
        <div class="brand">
          <img :src="logoImg" class="brand-logo" />
          <div>
            <h2>Foneswitch</h2>
            <p>Omnichannel</p>
          </div>
        </div>
      </div>
    </div>

    <!-- RIGHT -->
    <div class="right-section">
      <div class="form-card">
        <img :src="logoImg" class="top-logo" />
          <br />
        <h1>Welcome Back <br /> </h1>

        <p class="subtitle">
          Effortlessly take control of your Chat bots with our next-generation
          Bot management platform.
        </p>

        <form @submit.prevent="login">
          <!-- Username -->
          <div class="field">
            <!-- <label>Username</label> -->
            <input v-model="username" placeholder="Enter your email" />
          </div>

          <!-- Password -->
          <div class="field">
            <!-- <label>Password</label> -->
            <div class="password-wrap">
              <input
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="Enter your password"
              />


                  <i
                    type="button"
                    class="eye-btn"
                    @click="showPassword = !showPassword"
                  >
                    <Eye v-if="!showPassword" :size="18" />
                    <EyeOff v-else :size="18" />
            </i>
                
              

            </div>
          </div>

          <!-- Options -->
          <div class="row">
            <label class="remember">
              <input type="checkbox" v-model="rememberMe" />
              Remember me
            </label>
            <a href="#" class="link">Forgot Password?</a>
          </div>

          <!-- CAPTCHA -->
          <div
  style="
    display: flex;
    flex-direction: column;
    gap: 10px;
  "
>
  <!-- Canvas -->
  <canvas
    ref="captchaCanvas"
    width="180"
    height="50"
    style="
      border-radius: 10px;
      background: #f8fafc;
      align-self: flex-start;
    "
  ></canvas>

  <!-- Input + Button Row -->
  <div
    style="
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
    "
  >
    <input
      v-model="captchaInput"
      type="text"
      placeholder="Enter captcha"
      style="
        flex: 1;
        height: 44px;
        border: 1px solid #D4D7E3;
        border-radius: 10px;
        padding: 0 12px;
        font-size: 13px;
        color: #101828;
        outline: none;
      "
    />

    <button
      @click="generateCaptcha"
      type="button"
      style="
        height: 44px;
        width: 44px;
        border: 1px solid #D4D7E3;
        background: #fff;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #667085;
      "
    >
      <RefreshCw :size="18" />
    </button>
  </div>
</div>

          <p class="captcha-msg"> {{ captchaMessage }}</p>
          
          <!-- LOGIN -->
           <br/>
          <button class="login-btn" :disabled="loading">
            {{ loading ? "Loading..." : "Log In" }}
          </button>

          <p v-if="err" class="err">{{ err }}</p>
        </form>

        <p class="signup">
          Don't you have an account?
          <a href="#">Sign up</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
/* ✅ YOUR ORIGINAL SCRIPT (UNCHANGED) */
import { ref, onMounted, nextTick } from "vue";
import { useRouter } from "vue-router";
import { auth } from "@/services/auth";
import { useAgentSocket } from "@/services/socket";
import "@/assets/css/login.css";

import loginImg from "@/assets/images/omnibg.jpg";
import logoImg from "@/assets/images/login_poverdby.svg";
// import logoImg1 from "https://cdn.prod.website-files.com/67ab7d8cb75ff3a…044/67c133a20e2c58f76cd6ecc2_Logo-white%20(2).svg";
import VARS from "@/services/vars"
import { Eye, EyeOff,RefreshCw } from "lucide-vue-next";

const router = useRouter();
const { connect } = useAgentSocket();

const username = ref("");
const password = ref("");
const loading = ref(false);
const err = ref("");

const rememberMe = ref(true);
const showPassword = ref(false);

// captcha
const captchaCanvas = ref(null);
const captchaCode = ref("");
const captchaInput = ref("");
const captchaMessage = ref("");

function randomCaptcha(length = 5) {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let out = "";
  for (let i = 0; i < length; i++) {
    out += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return out;
}

function generateCaptcha() {
  captchaCode.value = randomCaptcha();
  captchaMessage.value = "";

  const canvas = captchaCanvas.value;
  if (!canvas) return;

  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = "#f4f6fb";
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.font = "28px Arial";
  ctx.fillStyle = "#1172FA";

  for (let i = 0; i < captchaCode.value.length; i++) {
    const ch = captchaCode.value[i];
    const x = 20 + i * 32;
    const y = 38 + Math.random() * 8;
    const angle = (Math.random() - 0.5) * 0.4;

    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(angle);
    ctx.fillText(ch, 0, 0);
    ctx.restore();
  }
}

function persistAuth(data) {
  auth.token = data.token;
  auth.user = data.user;

  localStorage.setItem("token", data.token);
  localStorage.setItem("user", JSON.stringify(data.user));

  if (rememberMe.value) {
    localStorage.setItem("remember_username", username.value);
  } else {
    localStorage.removeItem("remember_username");
  }
}

function redirectByRole(user) {
  const role = String(user?.role || "").toLowerCase();

  switch (role) {
    case "admin":
      router.push("/admin/dashboard");
      break;
    case "manager":
      router.push("/manager");
      break;
    default:
      router.push("/inbox");
  }
}

async function login() {
  if (!username.value || !password.value) {
    err.value = "Missing credentials";
    return;
  }

  if (captchaInput.value.toUpperCase() !== captchaCode.value) {
    err.value = "Invalid captcha";
    generateCaptcha();
    return;
  }

  loading.value = true;

  try {
    const r = await fetch(VARS.API_URL + "/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        username: username.value,
        password: password.value,
      }),
    });

    const data = await r.json();

    if (!data.ok) {
      err.value = data.message;
      return;
    }

    persistAuth(data);
    connect();
    redirectByRole(data.user);
  } catch (e) {
    err.value = "Network error";
  } finally {
    loading.value = false;
  }
}

onMounted(async () => {
  const saved = localStorage.getItem("remember_username");
  if (saved) username.value = saved;

  await nextTick();
  generateCaptcha();
});
</script>

<style scoped>
.login-container {
  display: flex;
  height: 100vh;
  background: #f5f6f8;
}

/* LEFT */
.left-section {
  flex: 1;
  position: relative;
}

.bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay {
  position: absolute;
  top: 20px;
  left: 20px;
  color: white;
}

.brand {
  display: flex;
  gap: 10px;
  align-items: center;
}

.brand-logo {
  width: 40px;
}

/* RIGHT */
.right-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-card {
  width: 420px;
  margin: 0 auto;
  text-align: center; /* important */
}

.top-logo {
  display: block;
  margin: 0 auto;
  width: 90px;
}


.logoTopWrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}


h1 {
  font-size: 26px;
  margin-bottom: 10px;
}

.subtitle {
  color: #666;
  margin-bottom: 20px;
}

.field {
  margin-bottom: 15px;
}

.field input {
  width: 100%;
  height: 45px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.password-wrap {
  display: flex;
  gap: 10px;
}

.row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.captcha-box {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.login-btn {
  width: 100%;
  height: 45px;
  background: #2f7cf6;
  color: white;
  border: none;
  border-radius: 8px;
}

.err {
  color: red;
}

.signup {
  margin-top: 20px;
}


.password-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.password-wrap input {
  width: 100%;
  padding-right: 40px;
}

.eye-btn {
  position: absolute;
  right: 10px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
}

.eye-btn:hover {
  color: #2f7cf6;
}


.refresh-btn {
  height: 44px;
  width: 44px;
  border: 1px solid #D4D7E3;
  background: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #667085;
  transition: all 0.2s ease;
}

.refresh-btn:hover {
  color: #1172FA;
  border-color: #1172FA;
  background: #f5f9ff;
}


.bg-img::after {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 255, 0.3); /* Blue tint */
  pointer-events: none; /* Allows clicking through the tint */
}

.bg-img {
  filter: brightness(0.8) saturate(2) hue-rotate(0deg);

}



</style>